/**
 * Created by saeed on 1/12/2017.
 */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {AuthService} from "./AuthService";
import {LoginComponent} from "../../login/login.component";
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
// Import our authentication service


@Injectable()
export class AuthGuard implements CanActivate {

  constructor(public dialog:MatDialog, private auth:AuthService, private router:Router) {
  }

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): boolean {
    // If user is not logged in we'll send them to the homepage
    if (!this.auth.loggedIn()) {
      this.router.navigate(['']);
      return false;
    }
    return true;
  }


  public openLoginDialog(then?:any):void {
    let dialogRef = this.dialog.open(LoginComponent, {
      width: '600px'
    });
    dialogRef.afterClosed().subscribe(result => {


      if(then)
        this.auth.updateLoginStatus(then);
      else
        this.auth.updateLoginStatus();

    });
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/services/auth/AuthGuard.ts